<template>
  <div>
    <h1 class="subheading text-center mt-8" style="color: #f28a3e">Merchandiser</h1>
    <div id="disha" class="team">
      <v-container>
        <v-row>
          <v-col
            v-for="(item, index) in dishaItems"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="2"
          >
            <a
              :href="item.href"
              target="_blank"
              style="text-decoration: none; display: block; width: 100%"
            >
              <div class="tile-container tileCtr">
                <div
                  class="icon-container iconCtr"
                  :style="{ backgroundColor: item.bgColor }"
                >
                  <v-icon :style="{ color: item.iconColor, fontSize: '2.5rem' }">
                    {{ item.iconName }}
                  </v-icon>
                </div>
                <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
              </div>
            </a>
          </v-col>
        </v-row>
      </v-container>
    </div>
    {{ authKey }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      authKey: localStorage.getItem("auth-key"),
      dishaItems: [
      {
          href: "https://spencers-visit.attabot.in/form",
          title: "Dynamic Form",
          iconName: "mdi-lumx",
          bgColor: "#F1F8E9",
          iconColor: "#8BC34A"
        },
        {
          href: "https://spencers-visit.attabot.in/photo-sharing-event",
          title: "Events",
          iconName: "folder_shared",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41"
        },
      ]
    };
  }
};
</script>

<style>
html {
  height: 100%;
  scroll-behavior: smooth;
}

.tileCtr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  background-color: #fff;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  height: 150px;
  min-height: 150px;
}

.tileCtr:hover {
  cursor: pointer;
  transform: translateY(-5px);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 15px;
}

.iconCtr {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 10px;
  transition: transform 0.2s ease;
}

.iconCtr:hover {
  transform: rotate(10deg);
}

.titleCtr {
  margin-top: 10px;
  font-size: 1rem;
  font-weight: bold;
  color: #f28a3e;
  width: 100%;
  text-align: center;
  white-space: normal;
  line-height: 1.2;
}

.tileCtr:hover .iconCtr {
  transform: scale(1.1);
}
</style>
